<template>
  <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
    {{ text }}
    <v-btn flat :color="color" @click="snackbar = null">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'StatusBar',
  data() {
    return {
      color: 'white',
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: null,
    };
  },
  watch: {
    statusMessage() {
      switch (this.statusMessage.type) {
        case 'info':
          this.color = 'blue';
          break;
        case 'error':
          this.color = 'red';
          break;
        case 'success':
          this.color = 'green';
          break;
        default:
          this.color = 'white';
      }
      this.text = this.statusMessage.text;
      this.snackbar = true;
    },
  },
  props: {
    statusMessage: {
      validator(v) {
        return v.text && v.type;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/StatusBar.vue